"use client";

import { useEffect } from "react";

const REVEAL_SELECTOR = "[data-scroll-reveal]";

export default function ScrollReveal() {
  useEffect(function setupScrollReveal() {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const revealBlocks = Array.from(document.querySelectorAll<HTMLElement>(REVEAL_SELECTOR));

    if (!revealBlocks.length) return;

    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      for (const block of revealBlocks) {
        block.classList.add("landing-reveal-visible");
      }
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add("landing-reveal-visible");
          observer.unobserve(entry.target);
        }
      },
      {
        rootMargin: "0px 0px -8% 0px",
        threshold: 0.04,
      }
    );

    for (const block of revealBlocks) {
      observer.observe(block);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return null;
}
